import type { ReferentialAssetEventType } from "./referential-asset-event-types.type";
import type { AssetEvent } from "@/entities/asset-event";

export const getAssetEventTypeAndSubtype = (
  assetEvent: AssetEvent,
  assetEventTypes: ReferentialAssetEventType[]
) => {
  const type = assetEventTypes.find(
    (eventType) => eventType.slug === assetEvent.type
  );

  const subType = type?.subtypes?.find(
    (eventSubType) => eventSubType.slug === assetEvent.sub_type
  );

  return {
    type,
    subType,
  };
};
